import {socialMedia} from "@/assets/social_media"

export const artists = {
    paululuh: {
      name: "Paululuh",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "paululuh.bsky.social",
        },
        {
          instagram: socialMedia.instagram.url + "paululuh",
        },
        {
          telegram: socialMedia.telegram.url + "pauululuh",
        },
        {
          twitter: socialMedia.twitter.url + "pauululuh",
        },
      ]
    },
    mespeth: {
      name: "Mespeth",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "mespeth.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "mespeth",
        },
        {
          telegram: socialMedia.telegram.url + "mespeth_art",
        },
        {
          tumblr: socialMedia.tumblr.url + "loveapologist",
        },
        {
          twitter: socialMedia.twitter.url + "mespeth_art",
        },
      ]
    },
    akuva: {
      name: "Akuva",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "akuva.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "akuva",
        },
        {
          tumblr: socialMedia.tumblr.url + "akuvaart",
        },
        {
          twitter: socialMedia.twitter.url + "akuvaart",
        },
      ]
    },
    gabrianne: {
      name: "Gabrianne",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "gabriannearts.bsky.social",
        },
        {
          twitter: socialMedia.twitter.url + "gabriannearts",
        },
      ]
    },
    aprion: {
      name: "Aprion",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "chillytokage.bsky.social",
        },
        {
          twitter: socialMedia.twitter.url + "chilly_tokage",
        },
      ]
    },
    graylynx: {
      name: "Graylynx",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "graylynx",
        },
      ]
    },
    ruffusbleu: {
      name: "Ruffus",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "ruffusbleu.bsky.social",
        },
        {
          twitter: socialMedia.twitter.url + "ruffusbleu",
        },
      ]
    },
    aleksika: {
      name: "AleksikaShvets",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "aleksikashvets.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "aleksikashvets",
        },
      ]
    },
    luradura: {
      name: "Lura Dura",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "LURAdura",
        },
        {
          twitter: socialMedia.twitter.url + "LURA94417389",
        },
      ]
    },
    arcane: {
      name: "Arcane",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "arcane.red",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "arcanewolfdragon",
        },
        {
          telegram: socialMedia.telegram.url + "ArcaneArt",
        },
        {
          twitter: socialMedia.twitter.url + "_Arcan3_",
        },
      ]
    },
    fjollettigeren: {
      name: "FjolletTigeren",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "fjollettigeren.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "fjollettigeren",
        },
        {
          twitter: socialMedia.twitter.url + "FjolletTigeren",
        },
      ]
    },
    flaich: {
      name: "Flaich",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "flaich",
        },
      ]
    },
    midnightdancer: {
      name: "Midnight Dancer",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "midnightdancer",
        },
      ]
    },
    mmare: {
      name: "Mmare",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "mmare",
        },
        {
          twitter: socialMedia.twitter.url + "NsfwMare",
        },
      ]
    },
    katsumizi: {
      name: "Katsumizi",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "katsumizi.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "katsumizi",
        },
        {
          twitter: socialMedia.twitter.url + "katsumizi",
        },
      ]
    },
    sadzarya: {
      name: "Sad Zarya",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "sadzarya",
        },
        {
          twitter: socialMedia.twitter.url + "sad_zarya",
        },
      ]
    },
    aduran: {
      name: "Aduran",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "aduran.bsky.social",
        },
        {
          twitter: socialMedia.twitter.url + "OnePotatoATime",
        },
      ]
    },
    cerberain: {
      name: "Cerberain",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "cerberain",
        },
        {
          twitter: socialMedia.twitter.url + "cerberain",
        },
      ]
    },
    kousuracon: {
      name: "KousuRaCon",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "kousuracon.bsky.social",
        },
        {
          telegram: socialMedia.telegram.url + "Bodega7",
        },
        {
          twitter: socialMedia.twitter.url + "KousuRaCon",
        },
      ]
    },
    stupidshepherd: {
      name: "Stupidsheperd",
      socialMedia: [
        {
          telegram: socialMedia.telegram.url + "StupidShepArt",
        },
        
      ]
    },
    gedebuk: {
      name: "Gedebuk",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "gedebuk.bsky.social",
        },
        {
          twitter: socialMedia.twitter.url + "Gedebuk_Fox",
        }
        
      ]
    },
    skylerie: {
      name: "Skylerie",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "skypawz.skyleriearts.com",
        },
        {
          instagram: socialMedia.instagram.url + "skyleriie",
        },
        {
          telegram: socialMedia.telegram.url + "skylerie",
        },
        {
          twitter: socialMedia.twitter.url + "Skypawz",
        }
      ]
    },
    reku: {
      name: "Reku",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "reku-art.co.uk",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "rekuillustration",
        },
        {
          twitter: socialMedia.twitter.url + "RekuArt",
        }
      ]
    },
    garoline: {
      name: "Garoline",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "garoline.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "kerotzuki",
        },
        {
          telegram: socialMedia.telegram.url + "Garoline",
        },
        {
          twitter: socialMedia.twitter.url + "GarolineArt",
        }
      ]
    },
    lordrex: {
      name: "LordRex",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "lordrex.bsky.social",
        },
        {
          telegram: socialMedia.telegram.url + "MetallosaurusRex",
        }
      ]
    },
    kousen: {
      name: "Kousen",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "kousenzephyr.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "kousen",
        },
        {
          tumblr: socialMedia.tumblr.url + "kousenzephyr",
        }
      ]
    },
    fungimagi: {
      name: "FungiMagi",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "fungimagi.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "fungimagi",
        },
        {
          telegram: socialMedia.telegram.url + "TheFungiMagi",
        }
      ]
    },
    dragotatsuki: {
      name: "Drago Tatsuki",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "dragotatsuki.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "dragotatsuki",
        },
        {
          telegram: socialMedia.telegram.url + "DragoSketchDump",
        }
      ]
    },
    fersky: {
      name: "Fersky",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "fersky.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "fersky",
        },
        {
          telegram: socialMedia.telegram.url + "Skyeeed",
        }
      ]
    },
    neku: {
      name: "Neku",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "nekudotexe.art",
        },
        {
          tumblr: socialMedia.tumblr.url + "nekudotexe",
        },
        {
          telegram: socialMedia.telegram.url + "nekudotexetg",
        }
      ]
    },
    trioza: {
      name: "Trioza",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "trioza.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "trioza",
        }
      ]
    },
    shanethekween: {
      name: "ShaneTheKween",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "shanethekween.bsky.social",
        },
        {
          instagram: socialMedia.instagram.url + "shane__kween",
        }
      ]
    },
    j450n: {
      name: "J450N",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "j450n2080.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "j450n2080",
        },
        {
          telegram: socialMedia.telegram.url + "J450N2080",
        }
      ]
    },
    arunkie: {
      name: "Arunkie",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "arunkie.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "xreicher",
        }
      ]
    },
    chrinos: {
      name: "Chrinos",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "chrinos.art",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "chrinosart",
        }
      ]
    },
    chechito: {
      name: "CheChito",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "chechito",
        }
      ]
    },
    taranfiddler: {
      name: "Taran Fiddler",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "tfiddlerart.bsky.social",
        },
        {
          instagram: socialMedia.instagram.url + "tfiddlerart",
        }
      ]
    },
    exal: {
      name: "Exal",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "exalinkwell.bsky.social",
        }
      ]
    },
    smallleaf: {
      name: "Small Leaf",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "smallleafart",
        },
        {
          telegram: socialMedia.telegram.url + "small_leaff"
        }
      ]
    },
    ambysweetdragon: {
      name: "Amby Sweet Dragon",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "ambysweetdragon",
        },
        {
          telegram: socialMedia.telegram.url + "Ambysweetdragon_Art"
        }
      ]
    },
    somfish: {
      name: "Som Fish",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "somfish",
        },
        {
          telegram: socialMedia.telegram.url + "somtheartist"
        }
      ]
    },
    panpydraws: {
      name: "Panpy Draws",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "panpydraws",
        },
        {
          telegram: socialMedia.telegram.url + "PanpyDraws"
        }
      ]
    },
    mleem: {
      name: "Mleem",
      socialMedia: [
        {
          furaffinity: socialMedia.furaffinity.url + "mleem",
        },
        {
          telegram: socialMedia.telegram.url + "mlemri"
        }
      ]
    },
    laser: {
      name: "Laser",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "laserpaints.com",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "laser",
        },
        {
          telegram: socialMedia.telegram.url + "LaserpaintsArt"
        }
      ]
    },
    isaacandel: {
      name: "Isaac Andel",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "isaacandel.bsky.social",
        },
        {
          telegram: socialMedia.telegram.url + "+uzXeMzSQ9es2MzZh#"
        }
      ]
    },
    jadedragoness: {
      name: "JadeDragoness",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "jadedragoness.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "jadedragoness",
        },
      ]
    },
    icebrew: {
      name: "IceBrew",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "icebrewmotion.bsky.social",
        }
      ]
    },
    fantine: {
      name: "Fantine",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "fantinestudio.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "fantine",
        },
        {
          telegram: socialMedia.telegram.url + "+uT5p9zhnnfAwN2M0"
        }
      ]
    },
    mcfan: {
      name: "McFan",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "mcfan.bsky.social",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "mcfan",
        }
      ]
    },
    douglaskim: {
      name: "Douglas Kim",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "douglas-kim.com",
        },
        {
          furaffinity: socialMedia.furaffinity.url + "kimmykun",
        },
        {
          telegram: socialMedia.telegram.url + "ArtisCanis",
        },
        {
          tumblr: socialMedia.tumblr.url + "douglas-kim",
        }
      ]
    },
    drakeistorm: {
      name: "Drakei Storm",
      socialMedia: [
        {
          bsky: socialMedia.bsky.url + "drakei.bsky.social",
        },
        {
          telegram: socialMedia.telegram.url + "drakei_arts",
        }
      ]
    }
  };